export const tableHeaders = ["Logo", "Name"];

export const MANAGER_CLIENTS_BREADCRUMBS = [
  { id: "/", name: "Home" },
  { id: "/washroomlogs", name: "Clients" },
];

export const DEFAULT_PAGE_SIZE = 10;
export const INITIAL_LAST_PAGE = 1000000000;
